<h1 light class="ion-text-center ion-no-margin text-primary-dark ion-padding-horizontal"
  >{{'COMPONENTS.SELECT_A_SCRIPT_TEMPLATE' | translate}}</h1
>
<h4 light class="ion-text-center text-primary-dark ion-padding-horizontal"
  >{{'COMPONENTS.CHOOSE_THE_ROUTE' | translate}}</h4
>
<app-tabs [tabs]="tabs" [basePath]="basepath"></app-tabs>
<ion-content class="max-height">
  <ion-router-outlet></ion-router-outlet>
</ion-content>
